// extracted by mini-css-extract-plugin
module.exports = {"auth":"auth_auth__1_nnF","auth-card":"auth_auth-card__2nX_O"};